import { useQuery } from "react-query";
import { get } from "../../data";

export const useUserTeams = () => {
    return useQuery({
        // placeholderData: [],
        queryKey: ["userTeams"],
        queryFn: async () => {
            const userTeams = await get("/tasking/assignments/groups");

            return userTeams.items.map(({ groupName, groupKey }) => {
                return {
                    value: groupKey,
                    displayText: groupName,
                    text: groupName,
                };
            });
        },
    });
};
